import React from 'react';
import loadable from '@loadable/component';
import { Helmet } from "react-helmet";

// constants
import { SALES_CONTACT_SUCCESS_MESSAGE } from '/src/lib/messages';
import { WEB_URL } from '/src/lib/endpoints';

// component
import ContactSalesPopup from '/src/components/ContactForms/ContactSalesPopup';
import { HeroSection } from './components/HeroSection';
import { FilteredReports } from './components/FilteredReports';
import { DataMethodology } from './components/DataMethodology';
import { FormSection } from './components/FormSection';

const SuccessPopup = loadable(
    () => import(/* webpackChunkName: "SuccessPopup" */ '/src/components/Reusable/SuccessPopup')
);



export const DataLandingPage = (props) => {

    const { type, dataType } = props;
    const path = props.location.pathname;

    const getHelmetData = () => {

        let page_title  = '';
        let description = '';

        if (type === 'region') {
            page_title  = `${dataType} Market Data & Insights: Real-Time Charts, Reports & APIs | MAGNiTT`;
            description = `Get instant access to real-time data on ${dataType}'s startup and investment landscape.`
        } else if (type === 'investment_type') {
            page_title  = `${dataType} Data & Insights: Real-Time Charts, Reports & APIs | MAGNiTT`;
            description = `Get instant access to real-time ${dataType} data across the startup and investment landscape.`
        }

        description += ' Explore interactive charts, downloadable reports and API integrations tailored to your workflow.'

        return {
            page_title,
            page_description: description
        }

    }

    const helmetData = getHelmetData();

    return (
        <div className="landing-page footer-margin-offset">
            
            {/* helmet */}
            <Helmet
                title={helmetData.page_title}
                link={[
                    {
                        rel: 'canonical',
                        href: `${WEB_URL}${path}`,
                    },
                ]}
                meta={[
                    {
                        name: 'description',
                        content: helmetData.page_description,
                    },
                    {
                        name: 'abstract',
                        content: helmetData.page_description,
                    },
                    {
                        property: 'og:type',
                        content: 'article',
                    },
                    {
                        property: 'og:url',
                        content: `${WEB_URL}${path}`,
                    },
                    {
                        property: 'og:title',
                        content: helmetData.page_title,
                    },
                ]}
                script={[
                    {
                        type: 'application/ld+json',
                        innerHTML: `{
                            "@context": "http://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "${dataType} Data",
                                "item": "${WEB_URL}${path}"
                            }]
                        }`,
                    },
                ]}
            />

            <HeroSection pageProps={props} />
            <FilteredReports pageProps={props} />
            <DataMethodology />
            <FormSection pageProps={props} />

            {/* modals */}
            <SuccessPopup
                msg={SALES_CONTACT_SUCCESS_MESSAGE}
                handleClose={() => { }}
            />

            <ContactSalesPopup page={props.hubspotFormSource} />

        </div>
    )

}